import type { AgentServiceAccount, OrgCategory } from "../../generated/core-api";

/**
 * Service accounts visible in an org workspace context: those with an org_role
 * entry matching the current org, or whose workspace is tied to the org via
 * the primary org_role on the account.
 */
export function filterServiceAccountsForOrg(
  accounts: AgentServiceAccount[],
  orgId: string,
  orgCategory: OrgCategory,
): AgentServiceAccount[] {
  return accounts.filter((account) =>
    account.org_roles?.some(
      (role) => role.org_id === orgId && role.org_category === orgCategory,
    ),
  );
}
